// extracted by mini-css-extract-plugin
module.exports = {"SleepState":"SleepState_SleepState__2P9pO"};